export default __webpack_public_path__ + "static/media/shwraimage.75a130c0.svg";